import { Color, Indicator } from '@crx-dev/hss-react-components';
import { format, differenceInDays } from 'date-fns';
import React, { useEffect, useState } from 'react';
interface StockCheckReminderInfoProps {
    enabled: boolean;
    weeksOverdue: number;
    date: string;
}

function StockCheckReminderInfo({ enabled, weeksOverdue, date }: StockCheckReminderInfoProps) {
    const [displayText, setDisplayText] = useState('');
    const [color, setColor] = useState<Color>('ElmoRed');

    useEffect(() => {
        const diffDays = differenceInDays(new Date(format(new Date(), 'yyyy-MM-dd')), new Date(date));
        const daysOverdue = weeksOverdue * 7;

        if (date == null) {
            setColor('ElmoRed');
            setDisplayText('Not Checked');
        } else if (diffDays > daysOverdue) {
            setColor('BeakerPink');
            setDisplayText(`${diffDays - daysOverdue} ${diffDays - daysOverdue === 1 ? 'day' : 'days'} overdue`);
        } else if (daysOverdue - diffDays > 6) {
            setColor('OscarGreen');
            setDisplayText('Checked');
        } else {
            setColor('FozzieOrange');
            if (daysOverdue === diffDays) {
                setDisplayText('Check due today');
            } else {
                setDisplayText(
                    `Check due in ${daysOverdue - diffDays} ${daysOverdue - diffDays === 1 ? 'day' : 'days'}`
                );
            }
        }
    }, [enabled, weeksOverdue, date]);

    return (
        <Indicator color={color} noWrap>
            {displayText}
        </Indicator>
    );
}

export default StockCheckReminderInfo;
